import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A2zContractListsComponent } from './a2z-contract-lists.component';
import { AngularMaterialModule } from '../../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../../pipes/index";


@NgModule({
  declarations: [A2zContractListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule, PipesModule

  ],
  exports: [A2zContractListsComponent]
})
export class A2zContractListsModule { }
